// AUTO-GENERATED SQL Builder (V40 Final) for OfferingMilestone
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class OfferingMilestoneSql {
  private ast = new SqlAst('OfferingMilestone', 'offeringMilestone');
  public readonly main: any = {};

  public guid: SqlField;
  public offeringId: SqlField;
  public offeringPackageId: SqlField;
  public label: SqlField;
  public mode: SqlField;
  public value: SqlField;
  public offsetDays: SqlField;
  public sortOrder: SqlField;
  public createdByUser: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public offeringPackage: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public offeringMilestoneShareList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('offeringMilestone', 'guid', '', 'id', 'offeringMilestone_guid');
    this.offeringId = new SqlField('offeringMilestone', 'offeringId', 'offering', 'id', 'offeringMilestone_offering');
    this.offeringPackageId = new SqlField('offeringMilestone', 'offeringPackageId', 'offeringPackage', 'id', 'offeringMilestone_offeringPackage');
    this.label = new SqlField('offeringMilestone', 'label', '', 'id', 'offeringMilestone_label');
    this.mode = new SqlField('offeringMilestone', 'mode', '', 'id', 'offeringMilestone_mode');
    this.value = new SqlField('offeringMilestone', 'value', '', 'id', 'offeringMilestone_value');
    this.offsetDays = new SqlField('offeringMilestone', 'offsetDays', '', 'id', 'offeringMilestone_offsetDays');
    this.sortOrder = new SqlField('offeringMilestone', 'sortOrder', '', 'id', 'offeringMilestone_sortOrder');
    this.createdByUser = createNavHybrid('offeringMilestone', 'offeringMilestone_createdByUser', 'User');
    this.offering = createNavHybrid('offeringMilestone', 'offeringMilestone_offering', 'Offering');
    this.offeringPackage = createNavHybrid('offeringMilestone', 'offeringMilestone_offeringPackage', 'OfferingPackage');
    this.updatedByUser = createNavHybrid('offeringMilestone', 'offeringMilestone_updatedByUser', 'User');
    this.offeringMilestoneShareList = createNavHybrid('offeringMilestone', 'offeringMilestone_offeringMilestoneShareList', 'OfferingMilestoneShare');
    this.id = new SqlField('offeringMilestone', 'id', '', 'id', 'offeringMilestone_id');
    this.isDeleted = new SqlField('offeringMilestone', 'isDeleted', '', 'id', 'offeringMilestone_isDeleted');
    this.createdBy = new SqlField('offeringMilestone', 'createdBy', '', 'id', 'offeringMilestone_createdBy');
    this.createdDate = new SqlField('offeringMilestone', 'createdDate', '', 'id', 'offeringMilestone_createdDate');
    this.updatedBy = new SqlField('offeringMilestone', 'updatedBy', '', 'id', 'offeringMilestone_updatedBy');
    this.updatedDate = new SqlField('offeringMilestone', 'updatedDate', '', 'id', 'offeringMilestone_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:OfferingMilestoneSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:OfferingMilestoneSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:OfferingMilestoneSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:OfferingMilestoneSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:OfferingMilestoneSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:OfferingMilestoneSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:OfferingMilestoneSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:OfferingMilestoneSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:OfferingMilestoneSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:OfferingMilestoneSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
